module.exports = __webpack_public_path__ + "files/943c94f89c864bae86f603aee2bf83ea.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Size3-Regular.woff
// module id = 1680
// module chunks = 60